import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={26}
    height={27}
    fill="none"
    {...props}
  >
    <Path
      fill="#DFE5E7"
      d="M13 .816c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13Z"
    />
    <Path
      fill="#fff"
      d="M21.275 21.852a7.79 7.79 0 0 0-.575-.769 8.657 8.657 0 0 0-1.12-1.106 8.9 8.9 0 0 0-1.989-1.239l-.022-.01c-1.204-.547-2.718-.926-4.6-.926-1.882 0-3.396.38-4.6.925l-.12.059a9.177 9.177 0 0 0-1.891 1.191 8.761 8.761 0 0 0-1.44 1.512 7.794 7.794 0 0 0-.432.649c-.004.007-.01.014-.013.021a5.887 5.887 0 0 0-.131.237c-.07.131-.101.206-.101.206v.049a12.418 12.418 0 0 0 8.721 3.563c3.403 0 6.486-1.365 8.735-3.576v-.036s-.076-.178-.245-.465a7.248 7.248 0 0 0-.177-.285ZM12.97 16.183a4.902 4.902 0 0 0 1.39-.2 4.575 4.575 0 0 0 1.385-.692 4.417 4.417 0 0 0 1.464-1.884 4.54 4.54 0 0 0 .3-1.1 4.953 4.953 0 0 0-.15-2.104 4.547 4.547 0 0 0-.691-1.385 4.418 4.418 0 0 0-1.68-1.375 4.567 4.567 0 0 0-1.074-.35 4.902 4.902 0 0 0-.944-.091c-2.602 0-4.591 1.99-4.591 4.59 0 2.602 1.99 4.591 4.59 4.591Z"
    />
  </Svg>
)
export default SvgComponent
